import { useState, useEffect } from 'react';

/**
 * Custom hook to detect media query matches (replaces Chakra's useBreakpointValue)
 */
export const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(() => {
		if (typeof window !== 'undefined') {
			return window.matchMedia(query).matches;
		}
		return false;
	});

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const mediaQuery = window.matchMedia(query);
		const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

		// Set initial value
		setMatches(mediaQuery.matches);

		// Listen for changes
		mediaQuery.addEventListener('change', handler);
		return () => mediaQuery.removeEventListener('change', handler);
	}, [query]);

	return matches;
};

/**
 * Hook to check if screen is mobile (< 640px - Tailwind's sm breakpoint)
 */
export const useIsMobile = (): boolean => {
	return useMediaQuery('(max-width: 639px)');
};

/**
 * Hook to check if screen is large (>= 1024px - Tailwind's lg breakpoint)
 */
export const useIsLargeScreen = (): boolean => {
	return useMediaQuery('(min-width: 1024px)');
};

export default useMediaQuery;
